/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// React icons
import { BsCheckCircleFill } from "react-icons/bs";
import { IoWalletOutline } from "react-icons/io5";
import { IoPaperPlaneOutline } from "react-icons/io5";
import { IoMailOutline } from "react-icons/io5";
import { IoCardOutline } from "react-icons/io5";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { IoLinkOutline } from "react-icons/io5";
import { IoHappyOutline } from "react-icons/io5";

// Vision UI Dashboard React example components
import TimelineItem from "examples/Timeline/TimelineItem";

// Vision UI Dashboard theme imports
import palette from "assets/theme/base/colors";

function StepByStepGuide() {
  const stepImageSize = "24px";
  return (
    <Card className="h-100">
      <VuiBox mb="16px">
        <VuiTypography variant="lg" fontWeight="bold" mb="5px" color="white">
          Step by Step Guide
        </VuiTypography>
        <VuiBox mb={2}>
          <VuiBox display="flex" alignItems="center">
            <BsCheckCircleFill color="green" size="15px" mr="5px" />
            <VuiTypography
              variant="button"
              color="text"
              fontWeight="medium"
              ml="5px"
              mr="2px"
            ></VuiTypography>{" "}
            <VuiTypography variant="button" color="text" fontWeight="regular">
              {" "}
              to Join Mr. Crypto Suport Channel
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      </VuiBox>
      <VuiBox>
        <TimelineItem
          icon={<IoWalletOutline size={stepImageSize} color={palette.info.main} />}
          title="Connect your Metamask wallet"
          dateTime="Step 1"
        />
        <TimelineItem
          icon={<IoPaperPlaneOutline size={stepImageSize} color={palette.info.main} />}
          title="Add your Telegram username in the form"
          dateTime="Step 2"
        />
        <TimelineItem
          icon={<IoMailOutline size={stepImageSize} color={palette.info.main} />}
          title="Add your Email address in the form"
          dateTime="Step 3"
        />
        <TimelineItem
          icon={<IoCardOutline size={stepImageSize} color={palette.info.main} />}
          title="Click with wich stable you want to pay"
          dateTime="Step 4"
        />
        <TimelineItem
          icon={<IoCheckmarkDoneCircleOutline size={stepImageSize} color={palette.info.main} />}
          title="Confirm your transaction in Metamask"
          dateTime="Step 5"
        />
        <TimelineItem
          icon={<IoLinkOutline size={stepImageSize} color={palette.info.main} />}
          title="Click on the link that will appear at the bottom of the form"
          dateTime="Step 6"
        />
        <TimelineItem
          icon={<IoHappyOutline size="28px" color={palette.success.focus} />}
          title="CONGRATULATIONS!!!"
          dateTime="You've made it!"
        />
      </VuiBox>
    </Card>
  );
}

export default StepByStepGuide;
